import { Box, Typography, useTheme } from "@mui/material";
import { LiveIcon } from "~components/Icons";

const LiveRunningFlag = () => {
  const theme: any = useTheme();
  const styles = {
    wrapper: {
      alignItems: "center",
      background: '#4FB69D',
      color: theme.palette.grey[0],
      display: "flex",
      height: "40px",
      justifyContent: "center",
      width: "100%",
      position: "fixed" as "fixed",
      zIndex: 999
    },
  };

  return (
    <Box sx={styles.wrapper}>
      <LiveIcon style={{ margin: "2px 16px 0 0" }} />
      <Typography>estamos ao vivo</Typography>
    </Box>
  );
};

export default LiveRunningFlag;
